import React from 'react';
import { Loader2 } from 'lucide-react';

/**
 * Reusable progress bar component for uploads and processing
 * @param {number} progress - Progress percentage (0-100), or -1 for indeterminate
 * @param {string} label - Label text to display
 * @param {string} variant - 'primary' | 'accent' | 'success'
 * @param {boolean} showSpinner - Show spinner icon
 * @param {string} className - Additional CSS classes
 */
export const ProgressBar = ({ 
  progress = 0, 
  label = '', 
  variant = 'primary',
  showSpinner = true,
  className = '' 
}) => {
  const isIndeterminate = progress < 0;
  
  const variantStyles = {
    primary: 'bg-primary',
    accent: 'bg-accent',
    success: 'bg-green-500'
  };
  
  const textStyles = {
    primary: 'text-primary',
    accent: 'text-accent',
    success: 'text-green-500'
  };
  
  return (
    <div className={`flex items-center space-x-2 text-sm font-medium ${textStyles[variant]} ${className}`} data-testid="progress-bar">
      {showSpinner && <Loader2 className="w-4 h-4 animate-spin" />}
      {label && <span>{label}{!isIndeterminate && ` ${Math.round(progress)}%`}</span>}
      <div className="w-20 h-1.5 bg-secondary rounded-full overflow-hidden">
        {isIndeterminate ? (
          <div className={`h-full ${variantStyles[variant]} animate-pulse`} style={{ width: '100%' }} />
        ) : (
          <div 
            className={`h-full ${variantStyles[variant]} transition-all duration-300`} 
            style={{ width: `${Math.min(100, Math.max(0, Math.round(progress)))}%` }}
          />
        )}
      </div>
    </div>
  );
};

export default ProgressBar;
